// TSM returns missing coordinates as NULL; the Sheriff DB returns them as 0.
// Treat both as "not plotted".
export const hasPlottableCoordinates = (lat, lng) => {
  const latitude = parseFloat(lat);
  const longitude = parseFloat(lng);
  return Number.isFinite(latitude) && Number.isFinite(longitude) && latitude !== 0 && longitude !== 0;
};

// Mirrors the API's rule for building a geocodable address:
// a street address, a state, and at least one of city or zip.
export const hasGeocodableAddress = ({ address1, city, state, zip }) => {
  const isFilled = (value) => typeof value === "string" ? value.trim() !== "" : !!value;
  return isFilled(address1) && isFilled(state) && (isFilled(city) || isFilled(zip));
};